import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagerySandBoxComponent } from './component/imagery-sand-box.component';
import { CoreModule } from '@ansyn/core';
import { FormsModule } from '@angular/forms';
import { ContextModule } from '@ansyn/context';

@NgModule({
	imports: [CommonModule, CoreModule, FormsModule, ContextModule],
	declarations: [ImagerySandBoxComponent],
	entryComponents: [ImagerySandBoxComponent]
})
export class ImagerySandBoxModule {
}



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/imagerySandBox/imagery-sand-box.module.ts